import React, { useEffect, useState } from "react";
import { Button } from "../../StyledCss/styledbtn";
import { AgGridReact } from "ag-grid-react";
import Header from "../Header";
import LeftNavBar from "../LeftNavBar";
import SlidingModal from "../SlidingModal/slidingModal";
import TenantForm from "../TenantForm/TenantForm";
import { AiFillDelete } from "react-icons/ai";
import toast from "react-hot-toast";
import { deleteTenant, getTenantsData } from "../../api/services/hroneApi";
import { convertKeysToCamelCase } from "../../util/convertCamelCase";
import PageHeader from "../PageHeader";
import TenantEditForm from "../TenantForm/TenantEditForm";
import FailureView from "../FailureView";
import LoadingView from "../LoadingView";
import { PageHeaderName } from "../../StyledCss/styledComponents";
import "./tenant.css";

const apiStatusConstants = {
  initial: "INITIAL",
  success: "SUCCESS",
  failure: "FAILURE",
  inProgress: "IN_PROGRESS",
};

const Tenant = () => {
  const [tenantsData, setTenantsData] = useState([]);
  const [singleTenantData, setSingleTenantData] = useState({});
  const [addTenantModal, setAddTenantModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [apiStatus, setApiStatus] = useState(apiStatusConstants.initial);

  useEffect(() => {
    tenantsHistoryData();
  }, []);

  const tenantsHistoryData = async () => {
    setApiStatus(apiStatusConstants.inProgress);
    try {
      const response = await getTenantsData();
      if (response.status === 200) {
        setApiStatus(apiStatusConstants.success);

        const data = convertKeysToCamelCase(await response.json());
        setTenantsData(data);
      } else {
        setApiStatus(apiStatusConstants.failure);
      }
    } catch (error) {
      setApiStatus(apiStatusConstants.failure);
    }
  };

  const onCloseModal = () => {
    setEditModal(false);
  };

  const onCloseAddTenantModal = () => {
    setAddTenantModal(false);
  };

  const notifyTenantDeleted = () =>
    toast.success("Tenant Deleted Successfully");

  const deleteTenantData = async (tenantId) => {
    try {
      const response = await deleteTenant(tenantId);
      if (response.status === 200) {
        setTimeout(() => {
          tenantsHistoryData();
        }, 1000);
        notifyTenantDeleted();
      }
    } catch (error) {}
  };

  const tenantHistoryTable = () => {
    const columnDefs = [
      {
        headerName: "TENANT ID",
        field: "tenantId",
        width: 120,
        filter: true,
        floatingFilter: true,
        suppressMenu: true
      },
      {
        headerName: "ORGANIZATION NAME",
        field: "organizationName",
        width: 250,
        filter: true,
        floatingFilter: true,
        suppressMenu: true,
        cellRenderer: (params) => {
         
          return (
            <p
              onClick={() => {
                setSingleTenantData(params.data);
                setEditModal(true);
              }}
            >
              {params.data.organizationName}
            </p>
          );
        },
      },
      {
        headerName: "ORGANIZATION CODE",
        field: "organizationCode",
        tooltipField: "description",
        width: 190,
        filter: true,
        floatingFilter: true,
        suppressMenu: true
      },
      {
        headerName: "ORGANIZATION URL",
        field: "organizationUrl",
        width: 190,
        filter: true,
        floatingFilter: true,
        suppressMenu: true
      },
      {
        headerName: "DOMAIN URL",
        field: "domainUrl",
        width: 190,
        filter: true,
        floatingFilter: true,
        suppressMenu: true
      },
      {
        headerName: "EMAIL",
        field: "contactEmail",
        width: 190,
        filter: true,
        floatingFilter: true,
        suppressMenu: true
      },
      {
        headerName: "CONTACT NUMBER",
        field: "mobileNumber",
        width: 190,
        filter: true,
        floatingFilter: true,
        suppressMenu: true
      },
      {
        headerName: "STATUS",
        field: "status",
        width: 120,
        filter: true,
        floatingFilter: true,
        suppressMenu: true
      },
      {
        headerName: "DELETE",
        cellRenderer: (params) => (
          <AiFillDelete
            id={params.data.id}
            onClick={() => deleteTenantData(params.data.tenantId)}
            style={{ fontSize: "18px", cursor: "pointer" }}
          />
        ),
      },
    ];

    const paginationSize = 20;

    return (
      <div
        style={{
          height: "70vh",
          marginLeft: "15px",
          marginRight: "15px",
          fontSize: "14px",
          fontFamily: "Arial, Helvetica, sans-serif",
        }}
        className="ag-theme-alpine history-container"
      >
        <AgGridReact
          rowData={tenantsData}
          columnDefs={columnDefs}
          pagination={true}
          paginationPageSize={paginationSize}
          enableCellTextSelection={true}
        ></AgGridReact>
      </div>
    );
  };
  const onClickRetry = () => tenantsHistoryData();

  const renderTenantsHistoryTable = () => {
    switch (apiStatus) {
      case apiStatusConstants.success:
        return tenantHistoryTable();
      case apiStatusConstants.failure:
        return <FailureView onClickRetry={onClickRetry} />;
      case apiStatusConstants.inProgress:
        return <LoadingView />;
      default:
        return null;
    }
  };

  return (
    <div>
      <Header />
      <div className="d-flex ">
        <LeftNavBar />
        <div className="page-content-wrapper">
          <PageHeader>
            <PageHeaderName>Tenants</PageHeaderName>

            <Button
              style={{ marginRight: "10px" }}
              onClick={() => setAddTenantModal(!editModal)}
            >
              Add Tenant
            </Button>
          </PageHeader>

          <div className="tenant-history-page">
            {renderTenantsHistoryTable()}
          </div>
          <SlidingModal
            closeBtn={onCloseAddTenantModal}
            isModalOpen={addTenantModal}
          >
            <TenantForm
              refreshData={tenantsHistoryData}
              setAddTenantModal={setAddTenantModal}
            />
          </SlidingModal>

          <SlidingModal closeBtn={onCloseModal} isModalOpen={editModal}>
            <TenantEditForm
              tenantsData={singleTenantData}
              refreshData={tenantsHistoryData}
              setEditModal={setEditModal}
            />
          </SlidingModal>

        </div>
      </div>
    </div>
  );
};

export default Tenant;
